<template>
  <div id="hero" class="hero-wrap style3">
    <div class="container-fluid">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="hero-content">
            <h1>
              Let's Make A <span>Brighter</span>Health For You &amp; Family
            </h1>
            <p>
              Lorem ipsum dolor sit amet consectetuer adipiscing Phasellus
              hendrerit lorem dolor sit nibh nec urna. In nisi neque, aliquet
              vel dapibus id dolor sit amet standard dummy text ever.
            </p>
            <div class="hero-btn">
              <a href="#appointment" class="btn style2">Book An Appointment</a>
              <a href="#about" class="btn style4">More About Us</a>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="hero-img-wrap hero-bg-7 bg-f"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>